export default {
  name: "PortalError",
  methods: {
    reloadPage() {
      window.location.reload();
    }
  }
};